import { create } from "zustand";

import { CustomerStatusOptions } from "../types/leads.types";
export interface LeadsFilterState {
  editedStatus: CustomerStatusOptions | null;
  editedNotes: string;
}

export interface EditStatusItem {
  label: string;
  value: string;
  description?: string
}

type State = LeadsFilterState;

type Actions = {
  actions: {
    setEditNotes: (editedNotes: string) => void;
    setEditStatus: (editedStatus: CustomerStatusOptions | null) => void;

  };
};

const leadsFilterStore = create<State & Actions>(set => {
  return {
    editedStatus: null,
    editedNotes: "",

    actions: {
      setEditNotes: editedNotes => set(() => {
        return { editedNotes }
      }),
      setEditStatus: editedStatus => set(() => {
        return { editedStatus }
      }),
    }
  }
})



export const useUpdateLeadsDetails = () =>
  leadsFilterStore(store => ({
    editedNotes: store.editedNotes,
    editedStatus: store.editedStatus,
    setEditNotes: store.actions.setEditNotes,
    setEditStatus: store.actions.setEditStatus
  }));
